import { ExperimentStore } from 'bernie-plugin-mobx';

import { ILocalization } from 'bernie-l10n';
import { updateSearch } from 'bernie-core';

import { SearchFormInputs } from '@shared-ui/search-tools-lodging';

import { SearchResultsStore } from 'src/common/stores/search-results-store';

import { getAdultsAndChildrenFromRooms } from 'src/common/utils/room-utils';

import { History, Location } from 'history';
import { PropertyDateRangeInput, PropertyFilterAmenity, SelectedValueInput } from 'src/common/__generated__/api';

interface UpdatedSearchParams {
  destination: string;
  regionId: string;
  startDate: string;
  endDate: string;
  adults: string;
  children: string;
  amenities?: string;
  price?: string;
  pwaDialog?: string;
}

export const updateResultsWithNewCriteria = (
  { propertySearchCriteriaInput: criteria }: SearchFormInputs,
  location: Location,
  history: History,
  searchResults: SearchResultsStore,
  experiment: ExperimentStore,
  l10n: ILocalization
) => {
  searchResults.clearDefaultRequestFields();
  searchResults.shouldFetch = true;

  const { primary, secondary } = criteria;
  const { regionName: destination, regionId, coordinates } = primary.destination;
  const { startDate, endDate } = getDateStringsFromDateRangeInput(primary.dateRange, l10n);
  const { adults, children } = getAdultsAndChildrenFromRooms(primary.rooms);
  const latLong = coordinates ? [coordinates.latitude, coordinates.longitude].join(',') : '';
  const params = new URLSearchParams(location.search);
  const searchParamStartDate = params.get('startDate');
  const searchParamEndDate = params.get('endDate');

  const newParams = {
    destination,
    latLong,
    regionId,
    startDate,
    endDate,
    adults,
    children,
    pwaDialog: null,
  };

  if (startDate !== searchParamStartDate && endDate !== searchParamEndDate) {
    // setting the price property of the newParams object explicitly to undefined so that updateSearch()
    // removes the price url parameter
    (newParams as UpdatedSearchParams).price = undefined;
  }

  if (experiment?.exposures?.Vrbex_generic?.bucket === 1) {
    (newParams as UpdatedSearchParams).amenities = getAmenities(searchResults, secondary?.selections);
  }

  // HACK: work around for a race condition between this updateSearch() call updating the url and the @shared-ui/dialog-context package updating the url
  setTimeout(() => updateSearch({ location, history, newParams, replace: false }));
};

export const getAmenities = (searchResults: SearchResultsStore, selections?: SelectedValueInput[]): string => {
  let amenities = searchResults.searchCriteria.amenities;

  if (selections) {
    amenities = amenities.filter(amenity => amenity !== PropertyFilterAmenity.PETS);
    const selectionsHasPets = selections.some(sel => sel.value === 'pets_allowed');
    if (selectionsHasPets) {
      amenities.push(PropertyFilterAmenity.PETS);
    }
  }

  return amenities.filter(Boolean).join();
};

export const getDateStringsFromDateRangeInput = (dateRange: PropertyDateRangeInput | null, l10n: ILocalization) => {
  if (dateRange === null) {
    return { startDate: undefined, endDate: undefined };
  }

  const { checkInDate, checkOutDate } = dateRange;
  const startDateObj = new Date(checkInDate.year, checkInDate.month - 1, checkInDate.day);
  const endDateObj = new Date(checkOutDate.year, checkOutDate.month - 1, checkOutDate.day);

  return {
    startDate: l10n.formatDate(startDateObj, { raw: 'yyyy-MM-dd' }),
    endDate: l10n.formatDate(endDateObj, { raw: 'yyyy-MM-dd' }),
  };
};
